<template>
  <div class="multiple-input">
    <div class="card-name" v-if="!!name">
      {{name}}
    </div>
    <div class="form-item" v-for="(item, index) in formItems" :key="index">
      <div class="question" v-if="!!item.question" :style="{color: item.questionColor || ''}">
        {{item.question}}
      </div>
      <div class="examples" v-if="!!item.examples" :style="{color: item.examplesColor || ''}">
        {{item.examples}}
      </div>
      <div class="input-wrapper">
        <template v-if="item.type === 'ChatInput'">
          <ChatInput v-model="item.value" :label="item.label" :placeholder="item.placeholder" :readonly="item.required" />
        </template>
        <template v-else-if="item.type === 'ChatTextarea'">
          <ChatTextarea v-model="item.value" :placeholder="item.placeholder" :mask-placeholder="item.maskPlaceholder" />
        </template>
        <template v-else-if="item.type === 'ChatSelect'">
          <ChatSelect v-model="item.value" :columns="item.columns" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ChatInput from "@/components/AIChatting/ChatInput/index.vue";
import ChatTextarea from "@/components/AIChatting/ChatTextarea/index.vue";
import ChatSelect from "@/components/AIChatting/ChatSelect/index.vue";
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    initFormItems: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      formItems: []
    }
  },
  watch: {
    initFormItems: {
      handler (newVal) {
        this.formItems = newVal.map(item => {
          return {
            value: '',
            ...item
          }
        })
      },
      immediate: true
    }
  },
  components: {
    ChatInput,
    ChatTextarea,
    ChatSelect
  },
  methods: {
    getValues() {
      return this.formItems.map(item => item.value)
    }
  }
}
</script>

<style scoped lang="scss">
.card-name {
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  margin-bottom: 10px;
}
.question {
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  margin-bottom: 10px;
}
.examples {
  font-size: 12px;
  font-weight: 400;
  line-height: 17.38px;
  color: rgba(121, 72, 234, 0.4);
  margin-bottom: 10px;
}
.form-item {
  margin-bottom: 17px;
}
.form-item:last-child {
  margin-bottom: 0;
}

</style>